module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-left-8edfe59d267ad47fbed40e1710984375.svg";